<template>
  <v-main class="grey lighten-4">
    <v-container fluid>
      <v-card class="rounded-xl" elevation="4">
        <!-- Cabeçalho -->
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-weight</v-icon>
          Gerenciamento de Pesos de Exames
          <v-spacer></v-spacer>
          <v-progress-circular v-if="mostrarLoading" indeterminate color="white" size="24"
            width="3"></v-progress-circular>
        </v-card-title>

        <v-divider></v-divider>

        <!-- Formulário de Seleção de Serviço -->
        <v-form v-if="mostrarSelecaoServico" v-model="formValido" ref="formServico" class="pa-4">
          <v-autocomplete v-model="servicoSelecionado" :items="listaServicos" item-text="nomeEspecialidade"
            item-value="idExameEspecialidade" label="Serviço"
            :rules="[v => !!v || 'Selecione um serviço para continuar']" outlined clearable return-object
            no-data-text="Nenhum serviço disponível" prepend-icon="mdi-medical-bag"
            hint="Selecione o serviço para configurar os pesos dos exames" persistent-hint
            :loading="carregandoServicos"></v-autocomplete>

          <v-card-actions class="px-0">
            <v-spacer></v-spacer>
            <v-btn rounded color="primary" @click="carregarExamesDoServico" :disabled="!formValido"
              :loading="mostrarLoading">
              <v-icon left>mdi-check</v-icon>
              Selecionar
            </v-btn>
            <v-btn rounded outlined color="grey darken-1" to="/servicosUnidade">
              <v-icon left>mdi-arrow-left</v-icon>
              Voltar
            </v-btn>
          </v-card-actions>
        </v-form>

        <!-- Tabela de Exames -->
        <div v-if="!mostrarSelecaoServico" class="pa-4">
          <v-card flat>
            <v-card-title class="px-0">
              <v-icon left color="primary">mdi-format-list-bulleted</v-icon>
              Exames do Serviço: {{ servicoSelecionado.nomeEspecialidade }}

              <v-spacer></v-spacer>

              <v-btn color="primary" text @click="voltarParaSelecaoServico" class="mr-2">
                <v-icon left>mdi-arrow-left</v-icon>
                Voltar
              </v-btn>

              <v-btn color="primary" outlined :disabled="!listaExames.length" @click="salvarAlteracoes"
                :loading="salvandoAlteracoes">
                <v-icon left>mdi-content-save</v-icon>
                Salvar
              </v-btn>
            </v-card-title>

            <v-divider class="my-4"></v-divider>

            <v-data-table :headers="cabecalhos" :items="listaExames" :search="termoBusca" :items-per-page="10"
              :footer-props="{
                'items-per-page-options': [10, 15, 20],
                'show-current-page': true
              }" no-data-text="Nenhum exame cadastrado para este serviço" class="elevation-1"
              :loading="carregandoExames" loading-text="Carregando exames...">
              <template v-slot:top>
                <v-text-field v-model="termoBusca" label="Pesquisar exame" prepend-icon="mdi-magnify" single-line
                  hide-details outlined dense class="mx-4 mt-4"></v-text-field>
              </template>

              <template v-slot:item.nomeExame="{ item }">
                <span class="font-weight-medium">{{ item.nomeExame }}</span>
              </template>

              <template v-slot:item.peso="{ item }">
                <v-edit-dialog :return-value.sync="item.peso" large @save="salvarPeso(item)"
                  @cancel="cancelarEdicaoPeso(item)">
                  <v-chip :color="getCorPeso(item.peso)" dark small label>
                    {{ item.peso || 0 }}
                  </v-chip>
                  <template v-slot:input>
                    <v-text-field v-model.number="item.peso" type="number" label="Novo peso" min="0" max="10"
                      :rules="[regraValidacaoPeso]" outlined dense autofocus></v-text-field>
                  </template>
                </v-edit-dialog>
              </template>

              <template v-slot:item.medicoExigidoRecep="{ item }">
                <v-switch v-model="item.medicoExigidoRecep" color="primary" hide-details
                  @change="item.alterado = true"></v-switch>
              </template>

              <template v-slot:no-results>
                <v-alert type="info" class="ma-4" outlined>
                  Nenhum resultado encontrado para "<strong>{{ termoBusca }}</strong>"
                </v-alert>
              </template>
            </v-data-table>
          </v-card>
        </div>
      </v-card>

      <!-- Diálogo de Erro -->
      <v-dialog v-model="dialogErro" max-width="400">
        <v-card>
          <v-card-title class="headline error--text">
            <v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
            Erro na Validação
          </v-card-title>

          <v-card-text>
            {{ mensagemErro }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogErro = false">
              Entendi
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Diálogo de Confirmação -->
      <v-dialog v-model="dialogConfirmacao" max-width="400">
        <v-card>
          <v-card-title class="headline">
            Confirmar Alterações
          </v-card-title>

          <v-card-text>
            Deseja salvar as alterações nos pesos e preferências médicas?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="dialogConfirmacao = false">
              Cancelar
            </v-btn>
            <v-btn color="primary" text @click="confirmarAlteracoes">
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'GerenciamentoPesosExames',

  data () {
    return {
      // Estados da UI
      mostrarSelecaoServico: true,
      mostrarLoading: false,
      carregandoServicos: false,
      carregandoExames: false,
      salvandoAlteracoes: false,
      formValido: false,
      dialogErro: false,
      dialogConfirmacao: false,
      mensagemErro: '',

      // Dados
      servicoSelecionado: null,
      listaServicos: [],
      listaExames: [],
      termoBusca: '',

      // Configuração da tabela
      cabecalhos: [
        { text: 'Nome do Exame', value: 'nomeExame', align: 'start', sortable: true },
        { text: 'Peso (0-10)', value: 'peso', align: 'center', sortable: true },
        { text: 'Preferência Médica', value: 'medicoExigidoRecep', align: 'center', sortable: false }
      ]
    }
  },

  mounted () {
    this.carregarServicos()
  },

  methods: {
    // Métodos de Carregamento de Dados
    async carregarServicos () {
      this.carregandoServicos = true
      try {
        const response = await administradorUnidadeService.administradorUnidade.retornarExameEspecialidade()
        this.listaServicos = response.data
      } catch (error) {
        console.error('Erro ao carregar serviços:', error)
        this.mostrarErro('Erro ao carregar serviços. Tente novamente.')
      } finally {
        this.carregandoServicos = false
      }
    },

    async carregarExamesDoServico () {
      if (!this.$refs.formServico.validate()) return

      this.mostrarLoading = true
      this.carregandoExames = true

      try {
        const response = await administradorUnidadeService.administradorUnidade
          .retornarExames(this.servicoSelecionado.idExameEspecialidade)

        this.listaExames = response.data.map(exame => ({
          ...exame,
          pesoInicial: exame.peso,
          medicoExigidoRecepInicial: exame.medicoExigidoRecep,
          alterado: false
        }))

        this.mostrarSelecaoServico = false
      } catch (error) {
        console.error('Erro ao carregar exames:', error)
        this.mostrarErro('Erro ao carregar exames. Tente novamente.')
      } finally {
        this.mostrarLoading = false
        this.carregandoExames = false
      }
    },

    // Métodos de Gestão de Estado
    voltarParaSelecaoServico () {
      this.mostrarSelecaoServico = true
      this.listaExames = []
      this.termoBusca = ''
    },

    // Métodos de Validação
    regraValidacaoPeso (value) {
      if (value === null || value === undefined || value === '') return 'O peso é obrigatório'
      const peso = Number(value)
      if (isNaN(peso)) return 'Deve ser um número'
      if (peso < 0) return 'O peso não pode ser negativo'
      if (peso > 10) return 'O peso máximo é 10'
      return true
    },

    getCorPeso (peso) {
      peso = Number(peso) || 0
      if (peso < 3) return 'red'
      if (peso < 6) return 'orange'
      return 'green'
    },

    // Métodos de Edição
    salvarPeso (item) {
      const peso = Number(item.peso)
      if (isNaN(peso) || peso < 0 || peso > 10) {
        item.peso = item.pesoInicial
        this.mostrarErro('O peso deve ser um número entre 0 e 10')
        return
      }
      item.alterado = true
    },

    cancelarEdicaoPeso (item) {
      item.peso = item.pesoInicial
    },

    // Métodos de Persistência
    salvarAlteracoes () {
      const examesAlterados = this.listaExames.filter(item => item.alterado)

      if (examesAlterados.length === 0) {
        this.mostrarErro('Nenhuma alteração foi feita para salvar')
        return
      }

      // Validar todos os pesos antes de salvar
      const possuiPesoInvalido = examesAlterados.some(item => {
        const peso = Number(item.peso)
        return isNaN(peso) || peso < 0 || peso > 10
      })

      if (possuiPesoInvalido) {
        this.mostrarErro('Alguns pesos estão inválidos. Corrija antes de salvar.')
        return
      }

      this.dialogConfirmacao = true
    },

    async confirmarAlteracoes () {
      this.dialogConfirmacao = false
      this.salvandoAlteracoes = true

      try {
        const examesAlterados = this.listaExames
          .filter(item => item.alterado)
          .map(({ idExame, peso, medicoExigidoRecep }) => ({
            idExame,
            peso,
            medicoExigidoRecep
          }))

        const response = await administradorUnidadeService.administradorUnidade
          .alterarPesoExame(examesAlterados)

        if (response.data) {
          // this.$toast.success('Alterações salvas com sucesso!')
          // Atualizar estados iniciais
          this.listaExames.forEach(item => {
            if (item.alterado) {
              item.pesoInicial = item.peso
              item.medicoExigidoRecepInicial = item.medicoExigidoRecep
              item.alterado = false
            }
          })
        }
      } catch (error) {
        console.error('Erro ao salvar alterações:', error)
        this.mostrarErro('Erro ao salvar alterações. Tente novamente.')
      } finally {
        this.salvandoAlteracoes = false
      }
    },

    // Métodos auxiliares
    mostrarErro (mensagem) {
      this.mensagemErro = mensagem
      this.dialogErro = true
    }
  }
}
</script>

<style scoped>
/* Estilos para a tabela */
.v-data-table {
  border-radius: 8px;
  overflow: hidden;
}

/* Estilo para os chips de peso */
.v-chip {
  min-width: 40px;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.v-chip:hover {
  transform: scale(1.1);
}

/* Ajustes de espaçamento */
.v-card__title {
  padding: 16px 24px;
}

/* Responsividade */
@media (max-width: 600px) {
  .v-card__title {
    flex-wrap: wrap;
  }

  .v-btn {
    margin-top: 8px;
  }

  .v-data-table {
    font-size: 0.8rem;
  }
}

/* Transições suaves */
.v-edit-dialog {
  transition: all 0.3s ease;
}

/* Estilo para o campo de busca */
.v-text-field--outlined>>>fieldset {
  border-color: rgba(0, 0, 0, 0.2);
}
</style>
